import React, { useContext, useEffect } from 'react'

import { GoogleMapsContext, GoogleMapsContextProps } from 'plugin-extension-google/shared/GoogleMaps/GoogleMapsProvider'

const MapPolylineWrapper = ({ onLoadMap }: { onLoadMap: (map: any) => void }): JSX.Element => {
    const { mapInstance } = useContext<GoogleMapsContextProps>(GoogleMapsContext)

    useEffect(() => {
        onLoadMap(mapInstance)
    }, [mapInstance]) // eslint-disable-line react-hooks/exhaustive-deps

    return <></>
}

export default MapPolylineWrapper
